import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import PageLayout from "../components/pages/PageLayout";
import RelatedLinks from "../components/pages/RelatedLinks";
import FaqAccordion from "../components/site/FaqAccordion";
import { FAQ_ITEMS } from "../content/faq";

const RELATED_PATHS = ["/services", "/private-label-cosmetics-india", "/contact"];

const FaqHero = () => (
  <section data-testid="faq-hero" className="pt-[76px] bg-ivory">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 lg:pt-24 pb-6 grid lg:grid-cols-[0.9fr_1.1fr] gap-10 items-end">
      <div>
        <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] font-semibold text-navy/55">
          <Link to="/" className="hover:text-navy transition-colors duration-300">Home</Link>
          <ChevronRight size={12} strokeWidth={1.5} />
          <span className="text-navy">FAQ</span>
        </nav>
        <p className="mt-10 text-xs uppercase tracking-[0.3em] font-semibold text-navy/60 mb-6">Good to Know</p>
        <h1 data-testid="page-h1" className="font-display text-navy text-4xl sm:text-5xl lg:text-6xl leading-[1.06] tracking-tight">
          Frequently Asked <em className="italic font-medium">Questions</em>
        </h1>
      </div>
      <p className="text-base md:text-lg leading-relaxed text-charcoal/85 max-w-xl lg:pb-2">
        Straight answers on how we work — manufacturing, exclusivity, minimum quantities, packaging, confidentiality and who owns the formula. Can&apos;t find what you need? <Link to="/contact" data-testid="faq-contact-link" className="text-navy font-semibold border-b border-navy/30 hover:border-navy transition-colors duration-300">Ask us directly</Link>.
      </p>
    </div>
  </section>
);

export default function Faq() {
  return (
    <PageLayout testId="faq-page">
      <FaqHero />
      <section data-testid="faq-list" className="bg-ivory pb-24 lg:pb-32">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 pt-10">
          <FaqAccordion items={FAQ_ITEMS} prefix="faq" />
        </div>
      </section>
      <RelatedLinks paths={RELATED_PATHS} />
    </PageLayout>
  );
}
